import React, { useState } from "react";
import "./Blog.css";

const ShareButtons = ({ blogUrl, blogTitle }) => {
  const [copied, setCopied] = useState(false);
  const encodedUrl = encodeURIComponent(blogUrl);
  const encodedTitle = encodeURIComponent(blogTitle);

  const handleCopyLink = () => {
    navigator.clipboard.writeText(blogUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="share-buttons-container">
      <div className="share-buttons-header">
        <span>Share this blog</span>
        <div className="share-buttons-line" />
      </div>

      <div className="share-buttons-wrapper">
        <a
          href={`https://api.whatsapp.com/send?text=${encodedTitle} - ${encodedUrl}`}
          target="_blank"
          rel="noopener noreferrer"
          className="share-btn whatsapp"
          title="Share on WhatsApp"
        >
          <i class="fa-brands fa-whatsapp"></i>
        </a>

        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`}
          target="_blank"
          rel="noopener noreferrer"
          className="share-btn facebook"
          title="Share on Facebook"
        >
         <i class="fa-brands fa-facebook"></i>
        </a>

        <a
          href={`https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`}
          target="_blank"
          rel="noopener noreferrer"
          className="share-btn twitter"
          title="Share on Twitter"
        >
          <i class="fa-brands fa-x-twitter"></i>
        </a>

        <button
          onClick={handleCopyLink}
          className="share-btn copy"
          title="Copy Link"
        >
          <i class="fa-solid fa-link"></i>
          {copied && <span className="copy-toast">Link Copied!</span>}
        </button>
      </div>
    </div>
  );
};

export default ShareButtons;
